'use client';

import { FOOTER_LINK_TABS } from '@/constants';
import { usePathname } from 'next/navigation';
import { useState } from 'react';
import { FooterLinkBox } from './FooterLinkBox';
import { useFooterTabs } from './FooterTabsContext';
import { isHousingDetailRoute, isProjectDetailRoute, shouldShowStaticFooter } from './footerRoutes';

type FooterLinkBoxSwitcherProps = {
  serverSlot: React.ReactNode;
};

export const FooterLinkBoxSwitcher = ({ serverSlot }: FooterLinkBoxSwitcherProps) => {
  const pathname = usePathname();
  const [initialPathname] = useState(pathname);
  const { detailTabs } = useFooterTabs();

  // First (server-rendered) load: keep the server slot — it is correct for the
  // initial URL and preserves SSR/SEO output. Crawlers always hard-load, so they
  // get this branch.
  if (pathname === initialPathname) {
    return <>{serverSlot}</>;
  }

  // After client-side navigation the root layout (and its server slot) is not
  // re-rendered, so recompute the footer on the client by pathname.
  if (isHousingDetailRoute(pathname) || isProjectDetailRoute(pathname)) {
    return detailTabs?.length ? <FooterLinkBox tabs={detailTabs} /> : null;
  }

  if (shouldShowStaticFooter(pathname)) {
    return <FooterLinkBox tabs={FOOTER_LINK_TABS} />;
  }

  return null;
};
